import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export default function Privacy() {
  return (
    <div>
      <div className="bg-[#EFEBE5] px-6 md:px-12 lg:px-24 py-3">
        <div className="max-w-7xl mx-auto flex items-center gap-2 text-sm font-body text-[#6B6B6B]">
          <Link to="/" className="hover:text-[#2D5016]">Accueil</Link>
          <ChevronRight className="w-3 h-3" />
          <span className="text-[#2D5016] font-medium">Politique de confidentialite</span>
        </div>
      </div>

      <section className="py-16 md:py-24 px-6 md:px-12 lg:px-24" data-testid="privacy-page">
        <div className="max-w-3xl mx-auto">
          <h1 className="font-heading text-4xl font-bold text-[#2C2C2C] mb-12">Politique de confidentialite</h1>

          <div className="space-y-8 font-body text-[#2C2C2C]/80 leading-relaxed text-sm">
            <div>
              <h2 className="font-heading text-xl font-semibold text-[#2C2C2C] mb-3">Responsable du traitement</h2>
              <p>VisitMonde, 6 place de la Fontaine, 78670 Villennes sur Seine, est responsable du traitement de vos donnees personnelles.</p>
              <p>Contact : <a href="mailto:dominicimarc64@gmail.com" className="text-[#2D5016] underline">contact@visitmonde.com</a></p>
            </div>

            <div>
              <h2 className="font-heading text-xl font-semibold text-[#2C2C2C] mb-3">Donnees collectees</h2>
              <p>Nous collectons les donnees suivantes :</p>
              <ul className="list-disc pl-6 mt-2 space-y-1">
                <li><strong>Formulaire de devis :</strong> nom, prenom, email, telephone, destination souhaitee, nombre de voyageurs, dates, budget, message</li>
                <li><strong>Newsletter :</strong> adresse email</li>
                <li><strong>Cookies :</strong> donnees de navigation (pages visitees, duree de visite)</li>
              </ul>
            </div>

            <div>
              <h2 className="font-heading text-xl font-semibold text-[#2C2C2C] mb-3">Finalites du traitement</h2>
              <ul className="list-disc pl-6 space-y-1">
                <li>Repondre a vos demandes de devis et assurer le suivi commercial</li>
                <li>Vous envoyer notre newsletter si vous y avez consenti</li>
                <li>Etablir des statistiques de frequentation du site</li>
                <li>Ameliorer notre offre de services</li>
              </ul>
            </div>

            <div>
              <h2 className="font-heading text-xl font-semibold text-[#2C2C2C] mb-3">Base legale</h2>
              <ul className="list-disc pl-6 space-y-1">
                <li><strong>Consentement :</strong> newsletter, cookies non essentiels</li>
                <li><strong>Interet legitime :</strong> amelioration des services, statistiques</li>
                <li><strong>Execution contractuelle :</strong> traitement des demandes de devis, reservation de voyages</li>
              </ul>
            </div>

            <div>
              <h2 className="font-heading text-xl font-semibold text-[#2C2C2C] mb-3">Duree de conservation</h2>
              <ul className="list-disc pl-6 space-y-1">
                <li>Donnees de devis : 3 ans apres le dernier contact</li>
                <li>Donnees newsletter : jusqu'au desabonnement</li>
                <li>Cookies : 13 mois maximum</li>
                <li>Donnees de reservation : duree legale de conservation (10 ans)</li>
              </ul>
            </div>

            <div>
              <h2 className="font-heading text-xl font-semibold text-[#2C2C2C] mb-3">Vos droits</h2>
              <p>Conformement au RGPD, vous disposez des droits suivants :</p>
              <ul className="list-disc pl-6 mt-2 space-y-1">
                <li>Droit d'acces a vos donnees</li>
                <li>Droit de rectification</li>
                <li>Droit de suppression (droit a l'oubli)</li>
                <li>Droit a la portabilite</li>
                <li>Droit d'opposition au traitement</li>
                <li>Droit a la limitation du traitement</li>
              </ul>
              <p className="mt-2">Pour exercer vos droits, contactez-nous a <a href="mailto:dominicimarc64@gmail.com" className="text-[#2D5016] underline">contact@visitmonde.com</a>.</p>
            </div>

            <div>
              <h2 className="font-heading text-xl font-semibold text-[#2C2C2C] mb-3">Hebergeur</h2>
              <p>Le site est heberge par Emergent (<a href="https://emergent.sh" target="_blank" rel="noopener noreferrer" className="text-[#2D5016] underline">emergent.sh</a>).</p>
            </div>

            <div>
              <h2 className="font-heading text-xl font-semibold text-[#2C2C2C] mb-3">Reclamation</h2>
              <p>Vous pouvez introduire une reclamation aupres de la CNIL (Commission Nationale de l'Informatique et des Libertes) si vous estimez que vos droits ne sont pas respectes.</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
